<template>
  <section class="shops-map">
    <div class="row row-shops-map">
      <div class="column small-12 medium-6">
        <form id="map-search-form" class="l-shops__main text-center medium-text-left">
          <h2>Lista sklepów</h2>
            <p v-if="exchangeEnded" class="exchange-ended-notice">                                                       
              Wymiana kapsli/zawleczek została zakończona w&nbsp;dniu 05.09.2026&nbsp;r.                                 
            </p>    
          <p>
            Znajdź sklep w&nbsp;którym odbierzesz nagrodę.
          </p>
          <div class="warning">
            <img src="/images/2026/kapsle.png" alt="" class="img-kapsle" />
            <div>
              <strong>UWAGA</strong>
              Jednorazowo można odebrać maksymalnie 4&nbsp;sztuki piwa
            </div>
          </div>
          <label class="text-left">
            LOKALIZACJA

            <!-- Google Autocomplete input injected here -->
          </label>
        </form>

        <p class="region-description">
          Loteria promocyjna prowadzona jest na&nbsp;terenie województw: mazowieckiego i&nbsp;lubelskiego.
        </p>
      </div>
      <div class="column small-12 medium-6 w-100">
        <div id="map" class="map"></div>
      </div>
    </div>
  </section>
</template>

<script>
import shopsData from '@/assets/sklepy/sklepy_20260903.json'
import { Loader } from 'google-maps'
import { MarkerClusterer } from '@googlemaps/markerclusterer/dist/index.umd.js'
import { isExchangeEnded } from '@/components_2026/exchangeEnded'

export default {
  name: 'ShopsMap',
  data() {
    return {
      exchangeEnded: isExchangeEnded()
    }
  },
  mounted() {
    this.loader.load().then(google => {
      this.initMap(google)
    })
  },
  /*
    Map implementation mostly migrated from Lezajsk project
    @link https://git.efigence.com/grupa-zywiec/lezajsk
  */
  created() {
    if (!shopsData) {
      console.warn('No shops Data')
      return
    }

    const apiKey = process.env.VUE_APP_GOOGLE_MAPS_API_KEY || 'my-api-key'
    if (apiKey === 'my-api-key') {
      console.warn('Google Maps API key not configured. Please set VUE_APP_GOOGLE_MAPS_API_KEY in your .env file')
    }

    this.loader = new Loader(apiKey, {
      version: 'weekly',
      libraries: ['places']
    })
  },
  methods: {
    initMap(google) {
      this.google = google

      const styles = [
        {
          featureType: 'water',
          elementType: 'geometry',
          stylers: [{ color: '#ca92a3' }, { lightness: 17 }]
        },
        {
          featureType: 'landscape',
          elementType: 'geometry',
          stylers: [{ color: '#4d0706' }, { lightness: 20 }]
        },
        {
          featureType: 'road.highway',
          elementType: 'geometry.fill',
          stylers: [{ color: '#bbbbbb' }, { lightness: 17 }]
        },
        {
          featureType: 'road.highway',
          elementType: 'geometry.stroke',
          stylers: [{ color: '#bbbbbb' }, { lightness: 29 }, { weight: 0.2 }]
        },
        {
          featureType: 'road.arterial',
          elementType: 'geometry',
          stylers: [{ color: '#bbbbbb' }, { lightness: 18 }]
        },
        {
          featureType: 'road.local',
          elementType: 'geometry',
          stylers: [{ color: '#bbbbbb' }, { lightness: 16 }]
        },
        {
          featureType: 'poi',
          elementType: 'geometry',
          stylers: [{ color: '#f5f5f5' }, { lightness: 21 }]
        },
        {
          featureType: 'poi.park',
          elementType: 'geometry',
          stylers: [{ color: '#dedede' }, { lightness: 21 }]
        },
        {
          elementType: 'labels.text.stroke',
          stylers: [{ visibility: 'on' }, { color: '#666666' }, { lightness: 16 }]
        },
        {
          elementType: 'labels.text.fill',
          stylers: [{ saturation: 36 }, { color: '#ffffff' }, { lightness: 40 }]
        },
        {
          elementType: 'labels.icon',
          stylers: [{ visibility: 'off' }]
        },
        {
          featureType: 'transit',
          elementType: 'geometry',
          stylers: [{ color: '#f2f2f2' }, { lightness: 19 }]
        },
        {
          featureType: 'administrative',
          elementType: 'geometry.fill',
          stylers: [{ color: '#fefefe' }, { lightness: 20 }]
        },
        {
          featureType: 'administrative',
          elementType: 'geometry.stroke',
          stylers: [{ color: '#999999' }, { lightness: 17 }, { weight: 1.2 }]
        }
      ]

      const map = new google.maps.Map(document.getElementById('map'), {
        center: new google.maps.LatLng(52.1789843, 21.4007651),
        styles: styles,
        scrollWheelZoom: !1,
        minZoom: 2,
        zoom: 10,
        gestureHandling: 'cooperative',
        mapTypeControl: !1,
        scaleControl: !1,
        zoomControl: !0,
        zoomControlOptions: { position: google.maps.ControlPosition.LEFT_TOP },
        streetViewControl: !1,
        fullscreenControl: !1
      })

      const markers = []
      const infoWindow = new google.maps.InfoWindow()

      for (let o = 0; o < shopsData.length; ++o) {
        const bigMarker = {
          url: 'images/map/pin26.png',
          size: new google.maps.Size(28, 40),
          origin: new google.maps.Point(0, 0),
          anchor: new google.maps.Point(9, 21),
          scaledSize: new google.maps.Size(28, 32)
        }

        const marker = new google.maps.Marker({
          map,
          position: { lat: Number(shopsData[o].lng), lng: Number(shopsData[o].lat) },
          icon: bigMarker,
          md5: `${shopsData[o].lng}-${shopsData[o].lat}`,
          info: {
            title: shopsData[o].name,
            description: `ul. ${shopsData[o].street ?? ''} <br/> ${shopsData[o].postCode ?? ''} ${shopsData[o].city ?? ''}`
          }
        })

        markers.push(marker)

        google.maps.event.addListener(
          marker,
          'click',
          (function(t, a) {
            return function() {
              infoWindow.setContent(
                `<div class="leaflet-popup leaflet-zoom-animated"><div class="leaflet-popup-content-wrapper"><div class="leaflet-popup-content"><h2>${shopsData[a].name}</h2><p>${shopsData[a].street}<br/>${shopsData[a].postCode} ${shopsData[a].city}</p></div></div><div class="leaflet-popup-tip-container"><div class="leaflet-popup-tip"></div></div></div>`
              )
              infoWindow.open(map, t)
            }
          })(marker, o)
        )
      }

      new MarkerClusterer({ map, markers })

      var d = google.maps.event.addListener(map, 'idle', () => {
        google.maps.event.removeListener(d)
      })

      const placeAutocomplete = new google.maps.places.PlaceAutocompleteElement({
        includedPrimaryTypes: ['geocode'],
        includedRegionCodes: ['pl']
      })
      Object.values(placeAutocomplete).forEach(value => {
        if (value instanceof HTMLInputElement) {
          value.placeholder = 'Wpisz adres'
        }
      })

      document.querySelector('.l-shops__main label').appendChild(placeAutocomplete)

      const onPlaceChanged = function({ placePrediction }) {
        placePrediction
          .toPlace()
          .fetchFields({ fields: ['viewport', 'location'] })
          .then(({ place }) => {
            const viewport = place.viewport
            const location = place.location

            viewport
              ? map.fitBounds(
                  new google.maps.LatLngBounds(
                    new google.maps.LatLng(viewport.getSouthWest().lat(), viewport.getSouthWest().lng()),
                    new google.maps.LatLng(viewport.getNorthEast().lat(), viewport.getNorthEast().lng())
                  )
                )
              : location && map.setViewByPoint(new google.maps.LatLng(location.lat(), location.lng()), 15)
          })
      }.bind(this)

      placeAutocomplete.addEventListener('gmp-select', onPlaceChanged)
    }
  }
}
</script>

<style lang="scss" scoped>
.shops-map {
  margin: 2.5rem 0;

  h2 {
    text-transform: capitalize;
    margin-bottom: 1rem;
  }

  .exchange-ended-notice {
    font-weight: 700;
    color: #d7b56a;
    border: 2px solid #d7b56a;
    padding: 0.75rem 1rem;
    margin-bottom: 1.5rem;
  }

  label {
    margin-bottom: 2rem;

    input {
      margin-top: 0.5rem;
    }
  }

  .region-description {
    font-size: rem-calc(14);

    @include breakpoint(medium) {
      font-size: rem-calc(18);
    }
  }

  ::v-deep gmp-place-autocomplete {
    border-radius: 0;
    border: 1px solid #cacaca;
    margin-top: 0.5rem;
  }
}

.row-shops-map {
  flex-direction: column;
  align-items: center;
  row-gap: 1rem;

  @include breakpoint(medium) {
    flex-direction: row-reverse;
  }

  .warning {
    display: flex;
    align-items: center;
    font-size: 0.875rem;
    font-weight: 400;
    margin: 2rem 0;
    gap: 1rem;

    @include breakpoint(small only) {
      flex-direction: column;
    }

    strong {
      color: #3b0400;
    }

    .img-kapsle {
      width: 75px;
    }
  }

  .map {
    width: 100%;
    height: 300px;
    background-color: #f0f0f0;

    @include breakpoint(medium) {
      height: 510px;
    }
  }
}
</style>
